import smallBall from '../../../assets/images/production/dataGovernance/ball-s.png'
import tool from '../../../assets/images/production/dataGovernance/tools.png'
import ball from '../../../assets/images/production/dataGovernance/ball.png'
import leftBall from '../../../assets/images/production/dataGovernance/left-ball.png'

import styles from './style.module.scss'

function DataGovernance() {
    return (
        <div className={`production-introduction-wrapper ${styles['datagovernance-wrapper']}`}>
            <div className={`banner ${styles['banner']}`}>
                <div className="title">大数据智能化产品</div>
                <div className={`content ${styles['content']}`}>烽火星空大数据智能化系列产品作为行业解决方案的核心技术支撑，主要包括大数据平台、数据治理工具、分析建模工具、应用开发工具，贯穿数据的存算、分析、应用、展示全生命周期，是新时代信息领域的“大国重器”</div>
            </div>
            <div className={styles['datagovernance-container']}>
                <div className={`introduction-container ${styles['introduction-container']}`}>
                    <p>产品简介<img src={smallBall} alt="" /></p>
                    <div className={`introduction-title ${styles['introduction-title']}`}>
                        <div className={`title-wrapper ${styles['title-wrapper']}`}>
                            <img src={leftBall} alt="" />
                            <div className={`title-container ${styles['title-container']}`}>
                                <div>
                                    <p><span>盘古</span><span>—— 数据治理工具</span></p>
                                    <p>烽火大数据治理工具以面向业务的专项治理为导向，构建覆盖从数据接入、数据处理、数据组织、数据治理到数据服务全流程的数据资源体系，包括多源异构的数据接入和处理组件、可视化数据资产组件等，最大化地发现数据核心价值，挖掘数据潜在能力，实现数据从探查，到接入、处理、开发、开放，再到形成知识沉淀的完整闭环。</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={`introduction-content ${styles['introduction-content']}`}>
                        <img src={tool} alt="" />
                        <img src={ball} alt="" />
                    </div>
                </div>
                <div className={styles['feature-container']}>
                    <p>产品特色</p>
                    <div className={styles['feature-content']}>
                        <div className={`feature-item ${styles['feature-item']}`}>
                            <div className={styles['img']}></div>
                            <p>AI赋能、易上手、自动化的数据治理体验透明化数据资产</p>
                            <p>完善的数据资源分类和编目机制，厘清数据资产，实现数据的“透明化”管理</p>
                        </div>
                        <div className={`feature-item ${styles['feature-item']}`}>
                            <div className={styles['img']}></div>
                            <p>全面化数据集成</p>
                            <p>全面丰富的数据集成能力，提供高效的执行引擎和数据加密算法通道</p>
                        </div>
                        <div className={`feature-item ${styles['feature-item']}`}>
                            <div className={styles['img']}></div>
                            <p>智能化数据开发</p>
                            <p>零代码可视化的开发界面，有效提升数据开发的效率</p>
                        </div>
                        <div className={`feature-item ${styles['feature-item']}`}>
                            <div className={styles['img']}></div>
                            <p>开放化数据服务</p>
                            <p>提供服务体系建设的敏捷工具，打造统一、开放、包容的服务资源大市场</p>
                        </div>
                        <div className={`feature-item ${styles['feature-item']}`}>
                            <div className={styles['img']}></div>
                            <p>体系化质量评估</p>
                            <p>对数据治理输入、输出、关键节点的质量全检测，输出完整、立体的评估报告</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default DataGovernance